export class User {
  isSignedIn = null;
  name = "";
  role = "";
  canvas_id = -1;
  ac_subjects = [];
  email = "";
  ddl_id = "";
  permissions = {};
  copied_offerings = {};

  constructor(data = {}) {
    this.isSignedIn = data.isSignedIn ?? false;
    this.name = data.name ?? "";
    this.role = data.role ?? "";
    this.canvas_id = data.canvas_id ?? -1;
    this.ac_subjects = data.ac_subjects ?? [];
    this.email = data.email ?? "";
    this.ddl_id = data.ddl_id ?? "";
    this.permissions = data.permissions ?? {};
    this.copied_offerings = data.copied_offerings ?? {};
  }

  isAC = () => {
    return this.role === "ac";
  };

  isPC = () => {
    return this.role === "pc";
  };

  isFaculty = () => {
    return this.role === "faculty";
  };

  isCC = () => {
    return this.role === "cc";
  };

  isOfferingCopied = (offeringId) => {
    return this.copied_offerings?.[offeringId] === true;
  };

  isCoordinatorForCourse = (courseCode) => {
    return (
      this.isCC() &&
      this.#hasPermission("coordinatedCourses", []).includes(courseCode)
    );
  };

  /**
   * Private method to check if the user has a specific permission.
   * Do not call this directly from outside the class.
   * To check for a specific permission, implement a public method
   * like `isFeatureEnabled()` that calls this method.
   * example:
   * ```javascript
   * isFeatureEnabled() {
   *   return this.isAC() || this.#hasPermission("feature_enabled");
   * }
   * ```
   * @param {string} permission - The permission to check.
   * @param default_value - The default value to return if the permission is not found.
   */
  #hasPermission = (permission, default_value) => {
    return this.permissions?.[permission] ?? default_value;
  };
}
